import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type AssignManualApplicationRequest, type StoreBaseReturn } from '@shared/api';

interface UseAssignManualApplicationStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  assignManualApplication: (searchParams: AssignManualApplicationRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useAssignManualApplicationStore = create<UseAssignManualApplicationStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  assignManualApplication: async (searchParams, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.assignManualApplication(searchParams, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
